<template>
  <el-dialog
    title="密码重置"
    :visible.sync="pwdVisible"
    :before-close="handleClose"
    :destroy-on-close="true"
    class="resetPwdDialog"
    width="380px"
  >
    <el-form
      :rules="rules"
      style="height: 100px"
      label-position="top"
      ref="refResetPwd"
      :model="passWordForm"
    >
      <el-col :span="24">
        <el-form-item prop="password">
          <template #label>
            <div class="customLabel">
              <div>新密码</div>
              <el-button
                type="text"
                class="copy"
                :disabled="!passWordForm.password.length"
                v-clipboard:copy="passWordForm.password"
                v-clipboard:success="onCopy"
                >复制密码</el-button
              >
            </div>
          </template>
          <el-input
            v-model="passWordForm.password"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <template slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="resetPassword()">提交</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { Message } from '@qs/ui'
import {
  generatePassword,
  validatePwd,
  pwdErrInfo,
} from '@/utils/passwordValidate'
import { setPassword } from '@/api/domain/organize'
import { useSubmitLock } from '@/utils/useUtils'

const pwdVisible = ref(false)
const passWordForm = ref({
  password: '',
  id: '',
})
const refResetPwd = ref(null)

const { loading: submitLoading, run } = useSubmitLock()
const rules = {
  password: [
    { required: true, message: '请输入密码', trigger: 'change' },
    { validator: validatePwd, message: pwdErrInfo, trigger: 'change' },
  ],
}

const onCopy = () => {
  Message.success('复制成功')
}

const resetPassword = () => {
  refResetPwd.value.validate((valid) => {
    if (!valid) return
    run(async () => {
      const { code, data } = await setPassword(passWordForm.value)
      if (code === 1 && data) {
        Message.success('密码重置成功')
        handleClose()
      }
    })
  })
}
const handleClose = () => {
  pwdVisible.value = false
  passWordForm.value.password = ''
  passWordForm.value.id = ''
}

const open = (id) => {
  pwdVisible.value = true
  passWordForm.value = {
    password: generatePassword(),
    id,
  }
}

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>
.resetPwdDialog {
  ::v-deep .el-form-item__label {
    width: 100% !important;
  }
  ::v-deep .is-shadow {
    box-shadow: none !important;
  }
  .customLabel {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .copy {
      cursor: pointer;
    }
  }
}
</style>
